module.exports = __webpack_public_path__ + "img/GB-WLS.14d50434.svg";